import ParticipantProfile from './ParticipantProfile.container';

export default ParticipantProfile;
